// Components==============
import Button from 'components/UI/Button';
import Modal from 'components/UI/Modal';
import deleteDoc from 'actions/group/update';
import React from 'react';
import './Modals.module.scss';
import { useDispatch } from 'react-redux';
// =========================

export default function DeleteItemModal({ setModalIsOpen, doc }) {
    const dispatch = useDispatch();

    function handleDelete() {
        dispatch(deleteDoc({ fileId: doc.id, deleteFile: true }));
    }

    return (
        <Modal closeModal={() => setModalIsOpen(false)}>
            <div styleName="content">
                <h3>Verwijderen</h3>
                <p>Weet je zeker dat je dit item wilt verwijderen?</p>
                <div>
                    <Button onClick={handleDelete}>Opslaan</Button>
                </div>
            </div>
        </Modal>
    );
}
